import * as _ from 'lodash'
import { AlertMessageType } from '../../config'
import { AlertUpdated } from '../redux/actions/AlertActions'
import ReduxStore from '../redux/Store'

let timer

class AlertService {
    queue = []
    defaultAutoClearDelay = 6000

    notifyAlertUpdated() {
        ReduxStore.dispatch({ type: AlertUpdated })
    }

    pushNewMessageToQueue(message, type, timeoutInMilliseconds) {
        var messageObject = {
            message: message,
            type: type,
            timeoutInMilliseconds: timeoutInMilliseconds,
            created: Date.now(),
            updated: Date.now(),
            count: 1,
        }
        this.queue.push(messageObject)
        return messageObject
    }

    updateCountAndTimestampOnDuplicateMessage(messageObject) {
        messageObject.count += 1
        messageObject.updated = Date.now()
        if (messageObject.type === AlertMessageType.Success) {
            clearTimeout(timer)
            this.setAutoClearTimer(messageObject)
        }
    }

    setAutoClearTimer(messageObject) {
        const service = this
        timer = setTimeout(() => {
            service.removeMessage(messageObject)
        }, messageObject.timeoutInMilliseconds)
    }

    addMessage(message, type, timeoutInMilliseconds) {
        const autoClearInMilliseconds =
            timeoutInMilliseconds !== undefined
                ? timeoutInMilliseconds
                : this.defaultAutoClearDelay
        const duplicateMessage = _.find(this.queue, {
            message: message,
            type: type,
        })
        let messageObject
        if (_.isUndefined(duplicateMessage)) {
            messageObject = this.pushNewMessageToQueue(
                message,
                type,
                autoClearInMilliseconds
            )
            if (autoClearInMilliseconds > 0) {
                this.setAutoClearTimer(messageObject)
            }
        } else {
            messageObject = duplicateMessage
            this.updateCountAndTimestampOnDuplicateMessage(duplicateMessage)
        }
        return messageObject
    }

    removeMessage(messageObject) {
        let index = this.queue.indexOf(messageObject)

        if (index > -1) {
            this.queue.splice(index, 1)
            this.notifyAlertUpdated()
        }
    }

    clearAllMessages() {
        this.queue = []
        this.notifyAlertUpdated()
    }

    clearMessageByType(type) {
        _.remove(this.queue, (messageObject) => {
            return messageObject.type === type
        })
        this.notifyAlertUpdated()
    }

    getSafeMessage(message) {
        const minimumErrorMessageSize = 3
        if (_.isEmpty(message) || _.size(message) <= minimumErrorMessageSize) {
            return 'Something went wrong.'
        }
        return message
    }

    addError(message, error, autoHide = false) {
        this.addMessage(
            this.getSafeMessage(message),
            AlertMessageType.Error,
            this.defaultAutoClearDelay
        )
        this.notifyAlertUpdated()
    }
    addWarning(message, error) {
        this.addMessage(this.getSafeMessage(message), AlertMessageType.Warning)
        this.notifyAlertUpdated()
    }
    addSuccess(message) {
        this.addMessage(message, AlertMessageType.Success)
        this.notifyAlertUpdated()
    }
    addInfo(message) {
        this.addMessage(message, AlertMessageType.Info)
        this.notifyAlertUpdated()
    }

    getAlertState() {
        return { messages: [...this.queue] }
    }
}

export const alertService = new AlertService()

export const initialAlertState = alertService.getAlertState()
